import { USER_SETTINGS_KEYS, USER_ROLES_BY_NAME } from 'src/constants/userSetting';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { livyConfig } from 'src/lib/livyTransport';

/**
 * Who may see a Livy surface, in one place.
 *
 * This is presentation only. The role is read from localStorage, which the user controls, so a
 * determined non-admin can render any of these pages. What actually stops them is the proxy, which
 * derives role and company from the verified Cognito token and refuses the request. Treat this as
 * "do not show a door that leads nowhere", never as a security boundary.
 */
const ADMIN_ROLES = [USER_ROLES_BY_NAME.LivableAdmin, USER_ROLES_BY_NAME.LivableSuperAdmin];
export const isLivyAdmin = role => ADMIN_ROLES.includes(String(role));
export const currentRole = () => localStorage.getItem(USER_SETTINGS_KEYS.userRole);

/**
 * Every Livy surface is admin gated for this rollout and needs the chat endpoint configured.
 *
 * The token is checked too, not just the role. Logging out clears both, but a session that simply
 * expires leaves the role behind, and without this the launcher would sit on the login screen
 * offering an assistant that can only answer 401.
 */
export const canUseLivy = () => isLivyAdmin(currentRole()) && Boolean(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken)) && Boolean(livyConfig());

/**
 * Wraps a Livy surface so a non-admin gets one consistent answer instead of each page inventing
 * its own. Presentation only: the proxy is what actually refuses the request.
 */
export const livyUnavailableMessage = 'Livy is not available for this account yet.';